import { Link } from "react-router-dom";
import "./Description.css";
import ActionButton from "../../ActionButton";
import ContactOptions from "../../ContactOptions";

const Description = () => {
  return (
    <section className="description">
      <div className="description-content">
        <ContactOptions />

        <h2 className="description-title">Nosso Projeto</h2>
        <p className="description-text">
          O Laboratório de Representação Científica da UFRJ é um projeto que une
          ciência, arte e educação para retratar a rica diversidade de aves
          presentes nos campi da universidade. Por meio de fotografias e
          ilustrações científicas, buscamos divulgar e valorizar a
          biodiversidade local, aproximando o público da natureza que nos cerca.
          Nosso trabalho é feito com cuidado, pesquisa e colaboração entre
          estudantes, pesquisadores e artistas, e tem como objetivo tornar o
          conhecimento científico acessível, sensível e visual.{" "}
        </p>
        <div className="description-button-row">
          <Link to="/sobre" style={{ textDecoration: "none" }}>
            <ActionButton
              text="Saiba Mais"
              color="var(--button-primary)"
              hoverColor="var(--button-primary-hover)"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Description;
